/** @jsx jsx */
import { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { Button, jsx, Text } from 'theme-ui'
import CartIcon from '~/assets/images/icons/cart.inline.svg'
import VisuallyHidden from '~/components/Generic/VisuallyHidden'
import { useCartFlyout } from '~/hooks/components/use-cart-flyout'

const NavMenuCartLink = ({ children, itemCount }) => {
  const { openCartFlyout } = useCartFlyout()
  const cartFlyoutTrigger = useRef()
  const [showItemCount, setShowItemCount] = useState(false)

  useEffect(() => {
    setShowItemCount(typeof itemCount === 'number')
  }, [itemCount])

  return (
    <Button
      key="cart"
      onClick={() => openCartFlyout(cartFlyoutTrigger)}
      variant="reset"
      ref={cartFlyoutTrigger}
      sx={{
        alignItems: 'center',
        cursor: 'pointer',
        display: 'flex',
        height: '64px',
        mr: -2,
        px: 2,
        pt: 0,
        pb: '2px',
        width: ['75px', null, 'auto'],
        '&:hover': {
          color: [null, null, 'brandTertiary'],
          svg: {
            color: [null, null, 'brandTertiary'],
          },
        },
      }}
    >
      <CartIcon
        sx={{
          height: 'auto',
          width: '26px',
        }}
      />
      <Text
        as="p"
        variant="navLink"
        aria-hidden="true"
        sx={{
          visibility: showItemCount ? 'visible' : 'hidden',
          ml: 1,
        }}
      >
        {itemCount || 0}
      </Text>
      <VisuallyHidden>
        <Text as="p">{`Shopping cart, contains ${itemCount} items, click to open.`}</Text>
      </VisuallyHidden>
    </Button>
  )
}

NavMenuCartLink.propTypes = {
  itemCount: PropTypes.number,
}

export default NavMenuCartLink
